import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierFragmentInformationsController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierFragmentInformationsController.php
* @route '/api/dossier/{dossier}/fragment/informations'
*/
const FetchDossierFragmentInformationsController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchDossierFragmentInformationsController.url(args, options),
    method: 'get',
})

FetchDossierFragmentInformationsController.definition = {
    methods: ["get","head"],
    url: '/api/dossier/{dossier}/fragment/informations',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierFragmentInformationsController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierFragmentInformationsController.php
* @route '/api/dossier/{dossier}/fragment/informations'
*/
FetchDossierFragmentInformationsController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return FetchDossierFragmentInformationsController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierFragmentInformationsController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierFragmentInformationsController.php
* @route '/api/dossier/{dossier}/fragment/informations'
*/
FetchDossierFragmentInformationsController.get = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchDossierFragmentInformationsController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierFragmentInformationsController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierFragmentInformationsController.php
* @route '/api/dossier/{dossier}/fragment/informations'
*/
FetchDossierFragmentInformationsController.head = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: FetchDossierFragmentInformationsController.url(args, options),
    method: 'head',
})

export default FetchDossierFragmentInformationsController